import { Injectable } from '@angular/core'
import { IModelBase } from 'common-components'
import { HttpClient } from '@angular/common/http'
import { TmrODataConfiguration } from '@exchange/services/core/odata/config'
import { ODataService } from 'common-services'

export interface IRemitLineView extends IModelBase {
  RemittanceId: number
  ServicePaymentId: number
  ServiceLineId: number
  ClaimId: number
  FileId: number
  FileKey: string
  PhysicianIdentificationCode: string
  ProviderName: string
  PatientId: string
  PatientName: string
  AuthorizationNumber: string
  DateOfService: string
  ProcedureCode: string
  PayerClaimControlId: string
  ProcedureCodeModifier: string
  BilledAmount: number
  AllowedAmount: number
  PaidAmount: number
  Quantity: number
  PatientResponsibilityAmount: number
  ContractualAdjustmentAmount: number
  ClaimAdjustmentReasonCode: string
  Status: string
  DaysInRemittanceStatus: number
  Identifier: string
  PlanName: string
  PatientEpisodeId: number
  ClaimType: string
  DaysSinceReceived: number
  ProcessingType: string
  ValidationStatus: string
  AvailableActions: any
  IsDataEditable: boolean
  IsDeleted: boolean
}

@Injectable()
export class RemitLineViewODataService extends ODataService<IRemitLineView> {
  constructor(
    protected http: HttpClient,
    protected config: TmrODataConfiguration
  ) {
    super(http, config)
    this.typeName = 'RemittancesView'
  }
}
